/**
 * The TrueSpace web tool — Algorithm_Additional Xlog3D_Asf_10Aug26:
 * "If True Spacing not available, get True Spacing from this app."
 *
 * The note that carries this link is drawn on the plot canvas, so the link is a
 * canvas item rather than an anchor. The URL is shown as its own text so it is
 * still readable in an exported plot, where nothing is clickable.
 */
export const TRUESPACE_URL = "https://truespace.vercel.app";

/** Label drawn on the canvas — the bare host, which reads as a link in print. */
export const TRUESPACE_LABEL = "truespace.vercel.app";

/**
 * Opens the tool in a NEW TAB. The plot on screen carries trace inputs held
 * only in memory, so navigating away in place would discard them.
 */
export function openTrueSpace() {
  window.open(TRUESPACE_URL, "_blank", "noopener,noreferrer");
}

/**
 * Converts a mouse position into paper.js project coordinates.
 *
 * Paper's own item events cannot be used for this. The plot canvas carries
 * paper's `resize` attribute, and paper deliberately skips setting a CSS size
 * on such an element — so on a high-DPI screen the canvas lays out at
 * devicePixelRatio times the size paper believes it has (measured: paper
 * viewSize 1300x1700, element 2600x3400). Paper then reads a click as being at
 * twice the coordinates it really is, and never hits the item.
 *
 * Deriving the scale from the element itself is correct on any display, and
 * leaves the rendered size of every plot untouched.
 */
export function projectPointFromEvent(event, rect, viewWidth) {
  if (!rect || !rect.width || !viewWidth) return null;
  const scale = rect.width / viewWidth;
  if (!scale) return null;
  return {
    x: (event.clientX - rect.left) / scale,
    y: (event.clientY - rect.top) / scale,
  };
}

/** Whether a project-space point falls inside a link's box. */
export function hitsLink(point, bounds) {
  if (!point || !bounds) return false;
  return (
    point.x >= bounds.left &&
    point.x <= bounds.right &&
    point.y >= bounds.top &&
    point.y <= bounds.bottom
  );
}

/**
 * Draws `prefix` followed by the TrueSpace link as blue underlined canvas text
 * on the note line at `y`, and returns the link's click box in project
 * coordinates (for hitsLink). `noteLine(y, text, { indent })` is the caller's
 * own note writer, so the link sits in that output's notes column.
 */
export function drawTrueSpaceNote(noteLine, y, prefix, Path) {
  const note = noteLine(y, prefix);
  const link = noteLine(y, TRUESPACE_LABEL, { indent: note.bounds.width + 3 });
  link.fillColor = "#0b57d0";
  const underline = new Path.Line(
    link.bounds.bottomLeft.add([0, 1]),
    link.bounds.bottomRight.add([0, 1])
  );
  underline.strokeColor = "#0b57d0";
  underline.strokeWidth = 0.6;
  const box = link.bounds.expand(6);
  return { left: box.left, right: box.right, top: box.top, bottom: box.bottom };
}
